import './Logo.css'

interface LogoProps {
    type: 'main' | 'small',
    scale?: number,
    online?: number
}

export const Logo = (props: LogoProps) => {

    return (
        <div className='logo-container-wrapper'
            style={{
                transform: `scale(${props.scale || 1})`,
            }}
        >
            <div
                className="logo-container"
                style={{
                    fontSize: props.type === 'main' ? '1.2rem' : '0.8rem',
                }}
            >
                <div className="logo-image-container">
                    <img
                        src={`/icons/${props.type === 'main' ? '128px' : '64px'}/logo.png`}
                        alt="logo"
                        style={{
                            width: props.type === 'main' ? '100px' : '64px',
                        }}
                    />
                </div>
                <div className="logo-text-container"
                    style={{
                        height: props.type === 'main' ? '40px' : '28px',
                        transform: `translateX(${props.type === 'main' ? '85px' : '50px'}) skew(-10deg)`,
                        paddingLeft: '8px',
                        paddingRight: '2px',
                    }}
                >
                    <p className="logo-upper-text">
                        GTA 5
                    </p>
                    <p className="logo-lower-text">
                        Race
                    </p>
                </div>
            </div>
            {
                props.online != null &&
                <div className='logo-online-text-container'>
                    <div className='online-indicator-container'>
                        <div className="online-indicator sm">
                            <div className="ring"></div>
                            <div className="ring"></div>
                            <div className="ring"></div>
                            <div className="dot"></div>
                        </div>
                    </div>
                    <p className='logo-online-text'>{props.online}</p>
                </div>
            }
        </div>
    )

}